import React, { useEffect, useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { UserContext } from '../../contexts/User';
import { NotificationContext } from '../../contexts/Notification';
import CenterCardLayout from '../../components/CenterCardLayout';

function SamlCallback() {
  const { workspaceId } = useParams();
  const history = useHistory();
  const {
    setUserToken, setAccessToken, setRefreshToken, setActiveWorkspace,
  } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);

  const completeSamlAuthentication = async (accessToken, refreshToken) => {
    try {
      // Set the tokens in the context
      setAccessToken(accessToken);
      setRefreshToken(refreshToken);

      // Decode the access token to get user and workspace info
      const tokenPayload = JSON.parse(atob(accessToken.split('.')[1]));

      if (tokenPayload.user) {
        setUserToken(accessToken);
      }

      if (tokenPayload.workspace) {
        setActiveWorkspace(tokenPayload.workspace);
        localStorage.setItem('shoot_active_workspace', JSON.stringify(tokenPayload.workspace));
      }

      displayNotification({
        message: 'SAML authentication successful!',
        severity: 'success',
      });

      // Redirect to dashboard
      history.push('/dashboard');
    } catch (error) {
      console.error('SAML authentication error:', error);
      displayNotification({
        message: 'SAML authentication failed. Please try again.',
        severity: 'error',
      });
      history.push('/login');
    }
  };

  useEffect(
    () => {
      const urlParams = new URLSearchParams(window.location.search);
      const accessToken = urlParams.get('accessToken');
      const refreshToken = urlParams.get('refreshToken');
      const workspaceIdParam = urlParams.get('workspaceId');

      if (accessToken && refreshToken && workspaceIdParam) {
      // Complete SAML authentication
        completeSamlAuthentication(accessToken, refreshToken, workspaceIdParam);
      } else {
      // No valid tokens found, redirect to error
        displayNotification({
          message: 'Invalid SAML authentication response.',
          severity: 'error',
        });
        history.push('/login');
      }
    },
    [workspaceId, history, displayNotification, setUserToken, setAccessToken, setRefreshToken, setActiveWorkspace],
  );

  return (
    <CenterCardLayout>
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <CircularProgress sx={{ color: 'var(--blue-3)' }} />
        <h3 style={{ marginTop: '20px', marginBottom: '10px' }}>
          Completing SAML Authentication
        </h3>
        <p className="text-muted">
          Please wait while we process your SAML login response...
        </p>
      </div>
    </CenterCardLayout>
  );
}

export default SamlCallback;
